<template>
    <div class="">
        <div class=" container-signup " >
            <div class="container" v-if="first" >
            <div class=" row justify-content-center text-center p-2 mt-2">
                <div class="col-4 col-md-2">
                    <button class="rounded-circle btn btn-primary p-3" >1</button>
                </div>
                 <div class="col-4 col-md-8 mt-3">
                     <div class="line mr-2"></div>
                     <!-- <hr class="bg-white p-2"> -->
                </div>
                 <div class="col-4 col-md-2">
                    <button class="rounded-circle btn btn-primary p-3" @click="goToSecond">2</button>
                </div>
            </div>
                <div class="signup-content mt-2">
                    <div id="signup-form" class="signup-form">
                        <!-- <h2>{{first}}</h2> -->
                        <h2 class="form-title">Let's set up your account</h2>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="name" name="name" id="name" placeholder="Full Name"/>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="bussines_name" name="email" id="email" placeholder="Bussiness Name"/>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="web_url" name="password" id="password" placeholder="Website URL"/>
                            <span class="field-icon" id="toggle-password">Optional</span>
                        </div>
                        
                        <div class="form-group">
                            <input type="tel" class="form-input" v-model="phone" name="re_password" id="re_password" placeholder="Phone Number"/>
                            <!-- <span class="field-icon" id="toggle-password">Optional</span> -->
                        </div>
                       
                        <div class="form-group">   
                            <button id="submit" class="form-submit" @click="makeIt()" >Continue <i class="fa fa-arrow-right"></i> </button>
                        </div>
                    </div>
                    
                </div>
            </div>

            <!--  -->
            <div class="container" v-if="second" >
            <div class=" row justify-content-center text-center p-2 mt-1">
                <div class="col-4 col-md-2">
                    <button class="rounded-circle btn btn-primary p-3" @click="goToOne">1</button>
                </div>
                 <div class="col-4 col-md-8 mt-3">
                     <div class="line mr-2"></div>
                     <!-- <hr class="bg-white p-2"> -->
                </div>
                 <div class="col-4 col-md-2">
                    <button class="rounded-circle btn btn-primary p-3">2</button>
                </div>
            </div>
                <div class="signup-content">
                    <form id="signup-form" class="signup-form" @submit.prevent="register">
                        <!-- <h2>{{first}}</h2> -->
                        <h2 class="form-title">Add your address</h2>
                        <p class="mt-n4 mb-5 p-title text-center">But why? Believe it or not, we need a physical address to make sure your emails comply with international anti-spam laws. Don't have an official business address? Learn about physical address alternatives</p>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="address" name="name" id="name" placeholder="Address line 1 (Street address or post office box)"/>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="city" name="city" id="email" placeholder="City"/>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="province"  id="province" placeholder="State/Province/Region"/>
                        </div>
                        
                        <div class="form-group">
                            <input type="text" class="form-input" v-model="country"  placeholder="Country"/>
                        </div>
                        <div class="form-group">   
                            <button id="submit" class="form-submit"> <span class="fa fa-spinner fa-spin" v-show="spin"></span> Done</button>
                            
                            <!-- <input type="button" name="submit" id="submit" class="form-submit" value=" /> -->
                        </div>
                    </form>
                </div>
            </div>
           
        </div>
        
    </div>
</template>

<script>

export default {
    data(){
        return{
            // first: '',
            name:'',
            bussines_name:'',
            web_url:'',
            phone:'',
            address:'',
            city:'',
            province:'',
            country:'',
            first: 1,
            second:0,
            spin:false
            // setacc:1,
            // setadd:2
        }
    },
    methods:{

       makeIt(){
           this.first = 0
           this.second = 1
       },
       // navigation 1
        goToSecond(){ 
            this.second = 1 
            this.first =0},
        //navigation 2
        goToOne(){ 
            this.second = 0 
            this.first =1
        },
        //method for navigation end here


       register(){
          let {name,phone,email,address,city, bussines_name, web_url} = this
           console.log({name,phone,email,address,city, bussines_name, web_url})
           this.spin = true

           setTimeout(() => {
               this.spin = false
               this.$router.replace({name:'dash'})
           }, 3000);
        //    
       }

    }
}
</script>


<style lang="css" src="./setup/styles.css" scoped></style>